'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useBreadcrumbStore } from '@/store'

const AppBreadcrumb = () => {
  const t = useTranslations()
  const { state } = useBreadcrumbStore()
  const { items } = state
  const [isSmall, setIsSmall] = useState(false)

  useEffect(() => {
    const check = () => setIsSmall(window.innerWidth < 640)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  const breadcrumbItems = items.length > 0 ? items : [{ label: t('dashboard'), href: '/', active: true }]
  const collapsed = isSmall && breadcrumbItems.length > 2

  const firstItem = breadcrumbItems[0]
  const lastItem = breadcrumbItems[breadcrumbItems.length - 1]
  const hiddenItems = breadcrumbItems.slice(1, -1)

  return (
    <Breadcrumb className="bg-background/20 supports-backdrop-filter:bg-background/10 border-b px-3 py-2 shadow-2xs backdrop-blur-lg">
      <BreadcrumbList>
        {collapsed ? (
          <>
            <BreadcrumbItem className="text-xs">
              <BreadcrumbLink asChild>
                <Link href={firstItem.href}>{firstItem.label}</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-xs" />
            <BreadcrumbItem className="text-xs">
              <DropdownMenu>
                <DropdownMenuTrigger aria-label="Show more" className="flex items-center">
                  <BreadcrumbEllipsis className="size-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start">
                  {hiddenItems.map((item, index) => (
                    <DropdownMenuItem key={index} asChild>
                      <Link href={item.href}>{item.label}</Link>
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-xs" />
            <BreadcrumbItem className="text-xs">
              <BreadcrumbLink asChild>
                <Link href={lastItem.href}>{lastItem.label}</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        ) : (
          breadcrumbItems.flatMap((item, index) => {
            const elements = [
              <BreadcrumbItem key={`item-${index}`} className="text-xs">
                <BreadcrumbLink asChild>
                  <Link href={item.href}>{item.label}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
            ]
            if (index < breadcrumbItems.length - 1) {
              elements.push(<BreadcrumbSeparator key={`sep-${index}`} className="text-xs" />)
            }
            return elements
          })
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
export default AppBreadcrumb
